module.exports = __webpack_public_path__ + "img/private.74da5460.png";